import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AccountDto } from "src/app/dto/login/account.dto";

@Injectable()
export class AccountService {
    private accountSeq!: number;
    private accountName!: string;
    private uuid!: string;

    constructor(private router: Router) {
        this.check();
    }

    private check(): void {
        if (!this.accountSeq || !this.accountName) {
            let accountSeq: string | null = localStorage.getItem("accountSeq");
            let accountName: string | null = localStorage.getItem("accountName");

            if (accountSeq && accountName) {
                this.accountSeq = +accountSeq;
                this.accountName = accountName;
            } else {
                this.router.navigateByUrl("");
            }
        }
    }

    public getAccountSeq(): number {
        return this.accountSeq;
    }

    public getAccountName(): string {
        return this.accountName;
    }

    public getAccountUUID(): string {
        return this.uuid;
    }

    public setAccount(accountDto: AccountDto): void {
        localStorage.setItem("accountSeq", "" + accountDto.seq);
        localStorage.setItem("accountName", accountDto.name);
        // localStorage.setItem("uuid", accountDto.uuid);

        this.accountSeq = accountDto.seq;
        this.accountName = accountDto.name;
        // this.uuid = accountDto.uuid;
    }

    public clear(): void {
        localStorage.removeItem("accountSeq");
        localStorage.removeItem("accountName");
        // localStorage.removeItem("uuid");

        this.accountSeq = 0;
        this.accountName = '';
        // this.uuid = '';
    }
}
